import Header from '../Components/ReusableComponents/Header'
import '../Styles/privacyPolicy.scss';

function PrivacyPolicy() {

  return (
    <div className="privacy-policy">
      <Header
        titleNeutral="Privacy policy"
      />
      <div className="privacy-policy-items">
        <div className="item">
          <p className='text'>
            Last updated: 12/03/2026
          </p>
          <p className='text'>At <strong>No61.app</strong>, we care about your privacy. This policy outlines what personal data we collect, how we use it, and the rights you have under the <strong>General Data Protection Regulation (GDPR)</strong> and the <strong>UK Data Protection Act 2018</strong>.</p>
        </div>
        <div className="item">
          <p className="title">1. Who We Are</p>
          <p className="text">No61 is operated by <strong>Nienke Dalstra</strong> and <strong>Vasileios Konstantoudakis</strong>.
            For any privacy-related inquiries, please contact us at <a href="mailto:colors@no61.app">colors@no61.app</a>.</p>
        </div>

        <div className="item">
          <p className="title">2. What We Collect</p>
          <p className="text">We collect only the data we need to provide our service:</p>
          <ul>
            <li><strong>Email address</strong> (for account creation and login)</li>
            <li><strong>Subscription and payment details</strong> (handled securely by Lemon Squeezy)</li>
            <li><strong>Email delivery metadata</strong> (via Resend, for transactional emails)</li>
          </ul>
          <p className="text">
            We do <strong>not</strong> collect:
          </p>
          <ul>
            <li>Full names or postal addresses</li>
            <li>Tracking data (e.g. analytics, IP logging)</li>
            <li>Sensitive personal data</li>
            <li>Cookies</li>
          </ul>
        </div>

        <div className="item">
          <p className="title">3. Legal Basis for Processing</p>
          <p className="text">We process your personal data based on:</p>
          <ul>
            <li><strong>Consent</strong> - when you sign up for an account</li>
            <li><strong>Contract</strong> -  to provide you with subscription services</li>
            <li><strong>Legitimate interest</strong> - to maintain secure account access and communicate essential updates</li>
            <li><strong>Legal obligations</strong> - for recordkeeping and compliance (e.g. invoicing)</li>
          </ul>
        </div>

        <div className="item">
          <p className="title">4. How We Use Your Data</p>
          <p className="text">We use your personal data solely to:</p>
          <ul>
            <li>Enable and secure your login</li>
            <li>Provide access to premium features</li>
            <li>Manage billing and subscriptions</li>
            <li>Send essential, account-related communications</li>
            <li>Respond to support or data access/deletion requests</li>
          </ul>
          <p className="text">We do <strong>not</strong> use your data for advertising, profiling, or third-party marketing.</p>
        </div>

        <div className="item">
          <p className="title">5. Third-Party Services</p>
          <p className="text">We work with the following services, all of which adhere to GDPR or equivalent privacy standards:</p>
          <ul>
            <li><strong>Supabase</strong> - user authentication and database (EU & US)</li>
            <li><strong>Lemon Squeezy</strong> - subscription billing and invoicing (US, GDPR-compliant)</li>
            <li><strong>Resend</strong> - transactional email delivery (US, SOC2-compliant)</li>
          </ul>
          <p className="text">These providers may process your data strictly for service-related purposes under data processing agreements.</p>
        </div>

        <div className="item">
          <p className="title">6. Cookies and Tracking</p>
          <p className="text">No61.app does <strong>not</strong> use cookies or tracking scripts.</p>
          <p className='text'>We do not store or analyze your behavior across sessions or websites.</p>
        </div>

        <div className="item">
          <p className="title">Your Rights</p>
          <p className="text">As a data subject under GDPR and UK data law, you have the right to:</p>
          <ul>
            <li><strong>Access</strong> your personal data</li>
            <li><strong>Rectify</strong> inaccurate or incomplete data</li>
            <li><strong>Delete</strong> your data permanently (“right to be forgotten”)</li>
            <li><strong>Restrict or object</strong> to data processing</li>
            <li><strong>Export</strong> your data (data portability)</li>
            <li><strong>Lodge a complaint</strong> with your local Data Protection Authority</li>
          </ul>
          <p className="text">To exercise your rights, email us at <a href="mailto:colors@no61.app">colors@no61.app</a>. <br />
          We will respond within 30 days.</p>
        </div>

        <div className="item">
          <p className="title">8. Data Retention</p>
          <ul>
            <li>Your account data remains on file as long as your account is active.</li>
            <li>Upon account deletion, we remove associated data from Supabase and Resend.</li>
            <li>Lemon Squeezy retains certain payment records to comply with tax and legal obligations.</li>
          </ul>
        </div>

        <div className="item">
          <p className="title">9. Data Security</p>
          <p className="text">We use industry-standard security measures to protect your data:</p>
          <ul>
            <li>HTTPS/TLS encryption</li>
            <li>Role-based access controls</li>
            <li>Secure third-party vendors</li>
            <li>Regular backups and infrastructure safeguards</li>
          </ul>
        </div>

        <div className="item">
          <p className="title">10. Policy Updates</p>
          <p className="text">This policy may be updated periodically.</p>
          <p className="text">If material changes occur, we will notify users via email and/or a notice on our website.</p>
        </div>

        <div className="item">
          <p className="title">11. Contact</p>
          <p className="text">If you have questions or want to exercise your rights under data protection laws, contact us at <a href="mailto:colors@no61.app">colors@no61.app</a>.
          </p>
          <p className="text">If you're dissatisfied with our response, you have the right to file a complaint with the UK Information Commissioner’s Office (ICO) or your local data authority.</p>
        </div>


      </div>
    </div>
  )
}

export default PrivacyPolicy